skyward.base.registerScript("browseLoadTimer", function (skyward, $)
{
    "use strict";
    
    var browseTimeoutEnabled;
    var browseTimeoutSeconds;
    var browseTimeoutSecondsMobile;
    var classNames =
    {
        longLoadBanner: "js-browseLongLoadBanner",
        longLoadResetButton: "js-browseLongLoadResetButton",
        browseBody: "browseBody"
    };

    var dataCache = (function ()
    {
        var map = new WeakMap();

        return function (browseRequest, browse)
        {
            var browseData = map.get(browse) || {};
            var dataObject =
            {
                get timeoutHandle()
                {
                    return browseData.timeoutHandle;
                },
                set timeoutHandle(value)
                {
                    // track the last browseRequest
                    browseData.browseRequest = browseRequest;
                    resetHandles();
                    browseData.timeoutHandle = value;
                    map.set(browse, browseData);
                },                
                get monitorRequestAjaxHandle()
                {
                    return browseData.monitorRequestAjaxHandle;
                },
                set monitorRequestAjaxHandle(value)
                {
                    browseData.monitorRequestAjaxHandle = value;
                    map.set(browse, browseData);
                },
                resetHandles: resetHandles
            };

            return dataObject;

            function resetHandles()
            {
                // don't reset anything if this isn't the latest browse request
                if (browseData.browseRequest !== browseRequest)
                {
                    return false;
                }
                if (browseData.timeoutHandle !== undefined)
                {
                    window.clearTimeout(browseData.timeoutHandle);
                }
                if (browseData.monitorRequestAjaxHandle !== undefined)
                {
                    browseData.monitorRequestAjaxHandle.abort();
                }
                return true;
            }
        };
    })();

    skyward.browseLoadTimer = skyward.browseLoadTimer || {};

    skyward.browseLoadTimer.initValues = function (timeoutEnabled, timeoutSeconds, timeoutSecondsMobile)
    {
        browseTimeoutEnabled = timeoutEnabled;
        browseTimeoutSeconds = timeoutSeconds;
        browseTimeoutSecondsMobile = timeoutSecondsMobile;
    };

    skyward.browseLoadTimer.monitorRequest = function (browseRequest, browse, browseData, routeModule, routeObject, routeAction)
    {
        var cachedBrowseHandles = dataCache(browseRequest, browse);

        cachedBrowseHandles.timeoutHandle = window.setTimeout(handleLongBrowseLoad, getTimeoutMiliseconds(), cachedBrowseHandles, browse, browseData, routeModule, routeObject, routeAction);

        browseRequest.always(function ()
        {
            if (cachedBrowseHandles.resetHandles())
            {
                removeBrowseBanner(browse);
            }
        });
    };

    function removeBrowseBanner (browse)
    {
        getBrowseBannerContainer(browse).find(classNames.longLoadBanner.dot()).remove();
    }

    function getTimeoutMiliseconds ()
    {
        return (skyward.global.mobileAccess ? browseTimeoutSecondsMobile : browseTimeoutSeconds) * 1000;
    }

    function handleLongBrowseLoad(cachedBrowseHandles, browse, browseData, routeModule, routeObject, routeAction)
    {
        var data = $.extend(
        {
            routeModule: routeModule,
            routeObject: routeObject,
            routeAction: routeAction
        }, browseData);

        cachedBrowseHandles.monitorRequestAjaxHandle = $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/Browse/MonitorBrowsePerformance",
            type: "POST",
            dataType: "JSON",
            data: data,
            activityIndicator: { hideGlass: true },
            success: function (responseData)
            {
                if (browseTimeoutEnabled && responseData.allowReset)
                {
                    displayLongRunningBrowseBanner(browse, responseData);
                }
            }
        });
    }

    function displayLongRunningBrowseBanner (browse, data)
    {
        var banner = $(data.banner);
        if (banner.length === 0)
        {
            return;
        }

        //prevent multiple banners
        removeBrowseBanner(browse);

        banner.addClass(classNames.longLoadBanner);
        var container = getBrowseBannerContainer(browse);
        banner.find(classNames.longLoadResetButton.dot()).one("click", { browse: browse, data: data }, resetViewAndFilter);
        container.prepend(banner);
        // trigger resize to reposition anchored modal layers if necessary
        skyward.window.notifyResize();
    }

    function getBrowseBannerContainer (browse)
    {
        var container;
        if (browse.browse !== undefined)
        {
            container = browse.browse.find(classNames.browseBody.dot());
            if (container.length === 0)
            {
                container = browse.browse;
            }
        }
        else
        {
            container = $("#" + browse.id);
        }
        return container;
    }

    function resetViewAndFilter (event)
    {
        var browse = event.data.browse;
        var data = event.data.data;
        var postData =
        {
            isLongLoad: true,
            browseModule: browse.pageModule || browse.browseModule,
            browseObject: browse.pageObject || browse.browseObject,
            browseScreen: browse.pageScreen,
            browseName: browse.browseName,
            taskName: browse.taskName,
            browseType: browse.browseType
        };
        skyward.browse.resetViewAndFilter(data.browseViewId, data.browseFilterId, browse.browseName, postData);
    }
});